export default `
  mutation updateCustomerEmailV2($email: String!) {
    updateCustomerEmailV2(email: $email){
      customer {
        email
      }
    }
  }
`
